<footer class="footer">
  <div class="footer-container">
    <div class="footer-grid">
      <!-- Company Info -->
      <div class="footer-column footer-company">
        <h3 class="footer-logo">{{ "footer.bipperz" | translate }}</h3>
        <p class="footer-text">
          {{ 'footer.text' | translate }}
        </p>
      </div>

      <!-- Quick Links -->
      <div class="footer-column">
        <h4 class="footer-title">{{ "footer.quick_links" | translate }}</h4>
        <ul class="footer-list">
          <li>
            <a href="#about" class="footer-link" (click)="openPolicyModal('about'); $event.preventDefault()">
              {{ 'footer.about' | translate }}
            </a>
          </li>
        </ul>
      </div>

      <!-- Contact Info -->
      <div class="footer-column">
        <h4 class="footer-title">{{ "footer.contact_us" | translate }}</h4>
        <ul class="footer-list footer-contact-list">
          <!-- Email -->
          <li class="footer-contact-item">
            <lucide-icon name="mail" class="footer-icon"></lucide-icon>
            <a href="mailto:info&#64;bipperz.com" class="footer-link">
              {{ 'footer.email' | translate }}
            </a>
          </li>

          <!-- Phone -->
          <li class="footer-contact-item">
            <lucide-icon name="phone" class="footer-icon"></lucide-icon>
            <a class="footer-link">
              {{ 'footer.phone' | translate }}
            </a>
          </li>

          <!-- Location -->
          <li class="footer-contact-item">
            <lucide-icon name="map-pin" class="footer-icon"></lucide-icon>
            <span class="footer-text">
              {{ 'footer.location' | translate }}
            </span>
          </li>
        </ul>
      </div>

      <!-- Social Media -->
      <div class="footer-column">
        <h4 class="footer-title">{{'footer.follow_us' | translate }}</h4>
        <div class="footer-socials">
          <!-- Facebook -->
          <a
            href="https://www.facebook.com/profile.php?id=61562285166415"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-social-btn"
            aria-label="Facebook"
          >
            <lucide-icon name="facebook" class="footer-social-icon"></lucide-icon>
          </a>

          <!-- Instagram -->
          <a
            href="https://www.instagram.com/bipperz_app?igsh=dXFmbXlwcGx6YmVq&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-social-btn"
            aria-label="Instagram"
          >
            <lucide-icon name="instagram" class="footer-social-icon"></lucide-icon>
          </a>

          <!-- LinkedIn (UPDATED URL) -->
          <a
            href="https://de.linkedin.com/company/bipperz"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-social-btn"
            aria-label="LinkedIn"
          >
            <lucide-icon name="linkedin" class="footer-social-icon"></lucide-icon>
          </a>

          <!-- TikTok  -->
          <a
            href="https://www.tiktok.com/@bipperz_app"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-social-btn"
            aria-label="TikTok"
          >
            <i class="footer-social-icon fa-brands fa-tiktok"></i>
          </a>
        </div>

        <p class="footer-text footer-note">
          {{ 'footer.motivation' | translate }}
        </p>
      </div>

    </div>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <p class="footer-bottom-text">
        © {{ currentYear }} {{ 'footer.copyrights' | translate }}
      </p>


      <p class="bpz-footer-credit">
        Coded with
        <svg class="bpz-footer-heartbeat" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314" fill-rule="evenodd"/>
        </svg>
        by <a href="https://www.bipperz.com/login">Bipperz.com</a>
      </p>

      <div class="footer-bottom-links">
        <a
          href="#"
          class="footer-bottom-link"
          (click)="openPolicyModal('privacy_policy'); $event.preventDefault()"
        >
          {{ 'footer.privacy_policy' | translate }}
        </a>

        <a
          href="#"
          class="footer-bottom-link"
          (click)="openPolicyModal('terms_of_services'); $event.preventDefault()"
        >
          {{ 'footer.terms_of_services' | translate }}
        </a>

        <a
          href="#"
          class="footer-bottom-link"
          (click)="openPolicyModal('impressum'); $event.preventDefault()"
        >
          {{ 'footer.impressum' | translate }}
        </a>

        <a
          routerLink="/account-deletion"
          class="footer-bottom-link"
        >
          {{ 'footer.account_deletion' | translate }}
        </a>
      </div>

    </div>
  </div>
</footer>
